import countries from 'i18n-iso-countries';
import pl from 'i18n-iso-countries/langs/pl.json';

countries.registerLocale(pl);

export type CountryOption = {
  code: string;
  label: string;
};

/**
 * Full sorted list of countries with Polish labels and ISO 3166-1 alpha-2 codes.
 * PL is pinned first for convenience.
 */
export const getCountryOptions = (): CountryOption[] => {
  const names = countries.getNames('pl', { select: 'official' });

  const sorted = Object.entries(names)
    .map(([code, label]) => ({ code, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'pl'));

  const pl = sorted.find((c) => c.code === 'PL');
  const rest = sorted.filter((c) => c.code !== 'PL');

  return pl ? [pl, ...rest] : sorted;
};

export const COUNTRY_OPTIONS = getCountryOptions();
